import { render, staticRenderFns } from "./PaywallForm.vue?vue&type=template&id=55499956&scoped=true"
import script from "./PaywallForm.vue?vue&type=script&lang=js"
export * from "./PaywallForm.vue?vue&type=script&lang=js"
import style0 from "./PaywallForm.vue?vue&type=style&index=0&id=55499956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55499956",
  null
  
)

export default component.exports